export const UsuarioEntity = {
    id: null,
    username: '',
    password: '',
    nombres: '',
    apellidoPaterno: '',
    apellidoMaterno: '',
    email: '',
    telefono: '',
    docIdentidad: '',
    tipoDocumento: 'DNI',
    profileImage: '',
    profile: {
        id: null,
        name: '',
        permissions: []
    }
};